<template>
  <v-footer absolute app class="footer">
    <div class="footer-left">
      <router-link to="/" exact class="footer-left__logo">
        <span class="footer-left__prepend">
          <img
            src="@/assets/footer__prepend.svg"
            alt="St. Jude Fitness Volunteer Leadership Conference"
          />
        </span>
        <div class="footer-left__separator"></div>
        <span class="footer-left__append">
          <img src="@/assets/footer__append.png" alt="The Power of One" />
        </span>
      </router-link>
    </div>
    <div class="footer-mid">
      <div class="footer-mid-top">
        <span class="org-email">
          <span>Need Help? </span>
          <span
            >Contact
            <a
              href="mailto:fitnessvlc@stjude.org?Subject=Need%20Help"
              class="org-link"
              >fitnessvlc@stjude.org</a
            ></span
          >
        </span>

        <a class="org-link org-link-invite" @click="openInviteModal"
          >Invite a Friend</a
        >

        <a
          class="org-link org-link-desktop"
          href="https://www.stjude.org"
          target="_blank"
        >
          stjude.org
        </a>
      </div>
      <div class="copyright">
        © Copyright 2021. St. Jude Children's Research Hospital, a
        not-for-profit, section 501(c)(3).
      </div>
    </div>
    <div class="footer-right">
      <a
        class="org-link org-link-mobile"
        href="https://www.stjude.org"
        target="_blank"
      >
        stjude.org
      </a>
      <img src="@/assets/logo-hospital.svg" alt="hospital logo" />
    </div>
    <InviteModal v-model="inviteModalVisible" />
  </v-footer>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {
      socials: [
        {
          url: "https://www.linkedin.com/company/145018/",
          icon: require("@/assets/social/linkedin.svg"),
          alt: "linkedin",
        },
        {
          url: "https://www.facebook.com/ideasunited/",
          icon: require("@/assets/social/facebook.svg"),
          alt: "facebook",
        },
        {
          url: "https://www.twitter.com/ideasunited",
          icon: require("@/assets/social/twitter.svg"),
          alt: "twitter",
        },
        {
          url: "https://www.instagram.com/ideasunited/",
          icon: require("@/assets/social/instagram.svg"),
          alt: "instagram",
        },
      ],
      inviteModalVisible: false,
    };
  },
  methods: {
    toTop() {
      window.scrollTo(0, 0);
    },
    openInviteModal() {
      this.inviteModalVisible = true;
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/styles/variables.scss";

.footer {
  display: flex;
  align-items: center;
  padding: 0px 10px;
  background: $primary !important;
  height: 80px;
  color: white;

  &-left {
    flex: 1;
    display: flex;
    align-items: center;
    a {
      color: white;
    }

    &__logo {
      display: flex;
      align-items: center;
    }

    &__separator {
      width: 1px;
      height: 67px;
      background: #64676c;
      margin: 5px 20px;
    }

    &__append {
      img {
        width: 126px;
      }
    }
  }

  .org-link {
    font-weight: 700;
    font-size: 15px;
    line-height: 17px;
    color: $jude-pink;
    &-mobile {
      display: none;
    }
    &-invite {
      color: $jude-yellow;
      text-decoration: underline;
      cursor: pointer;
    }
    &-desktop {
      flex-grow: 1;
      margin-left: 30px;
    }
  }

  &-mid {
    margin-right: 25px;
    text-align: right;

    &-top {
      display: flex;
      justify-content: space-between;
      align-items: baseline;
    }

    .org-email {
      color: $jude-pink;
      font-weight: 700;
      display: inline-block;
      margin-right: 24px;
    }
    .copyright {
      font-size: 12px;
      line-height: 16px;
      color: white;
      margin-top: 10px;
    }
  }
}

@media screen and (max-width: 960px) {
  .footer {
    height: 325px;
    padding: 0px 20px;
    position: relative;

    &-left {
      &__separator {
        width: 3px;
        background-color: #64676c;
        margin: 5px 20px;
      }
    }

    &-mid {
      text-align: center;
      margin-right: 0;
      .org-email {
        margin-right: 0;
      }
      &-top {
        font-size: 15px;
        .org-email {
          text-align: left;
          display: flex;
          flex-direction: column;
          > a,
          > span {
            display: block;
          }
        }
        .org-link-desktop {
          display: none;
        }
      }

      .copyright {
        text-align: left;
        margin-top: 15px;
        margin-right: -15px;
      }
    }

    &-right {
      padding-top: 30px;
      padding-bottom: 20px;
      border-top: 3px solid #64676c;
      width: 100%;
      text-align: center;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .org-link-mobile {
        display: block;
      }
      > img {
        width: 195px;
      }
    }
  }
}
</style>
